import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const bitcoinClientRoutes = [
  {
    id: 'bitcoin-import-instructions',
    trackingName: 'Bitcoin Import Instructions',
    path: 'web/view/bitcoin-import-instructions',
    lazy: async () => ({
      Component: (await import('@cash-web/account-bitcoin-feature-main')).JourneyBitcoinImportInstructions,
    }),
  },
  {
    id: 'bitcoin-buy',
    trackingName: 'Bitcoin Purchase',
    path: 'dl/view/bitcoin/buy',
    lazy: async () => ({
      Component: (await import('@cash-web/account-bitcoin-feature-main')).JourneyBitcoinPurchase,
    }),
  },
  {
    id: 'bitcoin-sell',
    trackingName: 'Bitcoin Sell',
    path: 'dl/view/bitcoin/sell',
    lazy: async () => ({
      Component: (await import('@cash-web/account-bitcoin-feature-main')).JourneyBitcoinSell,
    }),
  },
] as const satisfies JourneyRoute[]
